/* eslint-disable angular/file-name */
angular.module('zc.zenclerkS')
  .factory('MongoZcsDailyDiffStats', mongoZcsDailyDiffStats);


mongoZcsDailyDiffStats.$inject = ['$q', 'FacadeV2'];
function mongoZcsDailyDiffStats($q, FacadeV2) {
  class MongoZcsDailyDiffStats {
    static find(query, options = {}) {
      return $q((resolve, reject) => {
        if(!query) { query = {} }

        if(!query.apikey) {
          return reject('No apikey');
        }

        return FacadeV2.request(`/apikeys/${query.apikey}/zcs_daily_diff_stats`, {
          params: {
            match: query,
            sort: options.sort,
            limit: options.limit || 1000
          }
        }).then(res => {
          if((res.status !== 200) || (res.data != null ? res.data.error : undefined)) {
            return reject(res.data != null ? res.data.error : undefined);
          }
          return resolve(res.data);
        });
      });
    }
  }

  return MongoZcsDailyDiffStats;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/zcs_daily_diff_stats.service.js